import React, { useContext } from 'react';
import { makeStyles, Box } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import ArrowBackwardIcon from '@material-ui/icons/ArrowBack';
import UButton from 'components/UButton';
import UPaper from 'components/UPaper';
import { CONFIG } from 'constants/config';
import { BrowserView, MobileView } from 'react-device-detect';
import { getCurrentTenant } from 'constants/auth';
import { ValidacaoContext } from '../Context';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  pdf: {
    height: '100vh',
    paddingTop: '10px',
  },
  alert: {
    marginTop: '10px',
  },
});

function Display() {
  const {
    data, clear, loading, error,
  } = useContext(ValidacaoContext);
  const classes = useStyles();
  const currentTenant = getCurrentTenant();
  const urlFile = `${CONFIG.api.replace('TENANT_ID', currentTenant)}/service-docs/v1/certificados/publico/documento/${data?.codigo}`;

  return !loading && data && !error && (
    <UPaper className={classes.root} fullWidth>
      <UButton
        gutterTop={false}
        type="button"
        variant="outlined"
        color="secondary"
        onClick={clear}
        startIcon={<ArrowBackwardIcon />}
      >
        Voltar
      </UButton>
      <Box p={1}>
        <Alert severity="info">
          <AlertTitle>Resultado da Validação</AlertTitle>
          {
            data.certificadoStatus === 'REEDITADO'
              ? 'Este certificado foi reeditado. Clique em Visualizar '
              + 'para acessar o novo link de autenticidade.' : data.mensagem
          }
        </Alert>
        {
          data.certificadoStatus === 'REEDITADO'
            ? (
              <div>
                <UButton
                  gutterTop={false}
                  type="button"
                  href={`/docs/validar/${data.codigoAtualizado}`}
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="sm"
                >
                  Visualizar
                </UButton>
              </div>
            )
            : (
              <div>
                <BrowserView>
                  <embed
                    src={urlFile}
                    type="application/pdf"
                    width="100%"
                    height="500"
                    className={classes.pdf}
                  />
                </BrowserView>
                <MobileView>
                  <Alert className={classes.alert} severity="warning">
                    Atenção! Para visualizar o certificado clique no botão de download abaixo.
                  </Alert>
                  <UButton
                    gutterTop={false}
                    type="button"
                    href={`
                      ${CONFIG.api.replace('TENANT_ID', currentTenant)}/service-docs/v1/certificados/publico/documento/${data?.codigo}`}
                    fullWidth
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Download
                  </UButton>
                </MobileView>
              </div>
            )
        }
      </Box>
    </UPaper>
  );
}

export default Display;
